export const CxC_Columns = [
  {
    prop: "clienteid",
    label: "Codigo del cliente",
    width: 130,
    align: "center",
    sortable: true,
    fixed: true
  },
  {
    prop: "ncf",
    label: "Fact. No.",
    width: 70,
    align: "center",
    sortable: true,
    fixed: true
  },
  {
    prop: "fecha",
    label: "Fecha de Transaccion",
    width: 130,
    align: "center",
    sortable: true,
    fixed: false
  },
  {
    prop: "total_credito",
    label: "Monto Total de Credito",
    width: 160,
    align: "center",
    sortable: true,
    fixed: false
  },
  {
    prop: "producto",
    label: "Producto",
    width: 80,
    align: "center",
    sortable: true,
    fixed: false
  },
  {
    prop: "tarjetaid",
    label: "No. de Tarjeta",
    width: 100,
    align: "center",
    sortable: true,
    fixed: false
  },
  {
    prop: "nombre_tarjeta",
    label: "Tarjeta Habiente",
    width: 100,
    align: "center",
    sortable: true,
    fixed: false
  },
  {
    prop: "placa",
    label: "Placa",
    width: 100,
    align: "center",
    sortable: true,
    fixed: false
  },
  {
    prop: "vehiculo",
    label: "Vehiculo",
    width: 100,
    align: "center",
    sortable: true,
    fixed: false
  }
];
